import { useFreshness } from "./hooks/useOcrHealthData";
import { SourceMixDonut } from "./panels/SourceMixDonut";
import { PerSourceAccuracyTrend } from "./panels/PerSourceAccuracyTrend";
import { PriorApplicationStats } from "./panels/PriorApplicationStats";
import { UnresolvedVolumeTimeline } from "./panels/UnresolvedVolumeTimeline";
import { PerFieldDrilldownTable } from "./panels/PerFieldDrilldownTable";
import { RecentCorrectionsStream } from "./panels/RecentCorrectionsStream";
import { ProfileFieldLearningPanel } from "./panels/ProfileFieldLearningPanel";
import styles from "./ocr-health.module.css";

export function OcrHealthPage() {
  return (
    <div className={styles.page}>
      <DashboardHeader />
      <div className={styles.grid}>
        <SourceMixDonut />
        <PerSourceAccuracyTrend />
        <PriorApplicationStats />
        <UnresolvedVolumeTimeline />
      </div>
      <PerFieldDrilldownTable />
      <ProfileFieldLearningPanel />
      <RecentCorrectionsStream />
    </div>
  );
}

function DashboardHeader() {
  const { data } = useFreshness();
  const ageLabel = formatAge(data?.ageSeconds ?? 0);
  return (
    <div className={styles.header}>
      <h1 className={styles.pageTitle}>OCR Health</h1>
      <span className={styles.freshness}>
        {data?.lastCorrectionAt
          ? `Data current as of ${new Date(data.lastCorrectionAt).toLocaleTimeString()} (${ageLabel})`
          : "No corrections recorded yet"}
      </span>
    </div>
  );
}

function formatAge(seconds: number): string {
  if (seconds < 60) return `${seconds}s ago`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  return `${Math.floor(seconds / 86400)}d ago`;
}
